import { PLATFORM_URL } from "app/constants/variables";
import { GenericResponse } from "../types";
import request from "../request";
import { CreatePaymentLinkPayment, CreatePaymentPayload, CreatePaymentResponse, FinalizePaymentRequestPayload, RetrievePaymentPayload } from "./types";

export const createPayment = ({ token, publicKey, ...payload }: CreatePaymentPayload) => {
  return request.post<GenericResponse<CreatePaymentResponse>>("v1/payments/requests", payload, {
    baseURL: PLATFORM_URL,
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
      'X-BU-PUBLIC-KEY': publicKey
    },
  });
};


export const retrievePayment = ({ publicKey, id }: RetrievePaymentPayload) => {
  return request.get<GenericResponse<CreatePaymentResponse>>(`v1/payments/requests/${id}`, {
    baseURL: PLATFORM_URL,
    headers: {
      'X-BU-PUBLIC-KEY': publicKey
    },
  });
};

export const createPaymentLinkPayment = ({ token, paymentId, businessProfileId, ...payload }: CreatePaymentLinkPayment) => {
  return request.post<GenericResponse<CreatePaymentResponse>>(`v1/payments/links/${paymentId}/requests`, payload, {
    baseURL: PLATFORM_URL,
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(businessProfileId && { 'X-BU-PROFILE': businessProfileId })
    },
  });
};

export const finalizePaymentRequest = ({ token, paymentRequestId, businessProfileId, code }: FinalizePaymentRequestPayload) => {
  return request.post<GenericResponse<CreatePaymentResponse>>(`v1/payments/requests/${paymentRequestId}/finalize`, { code }, {
    baseURL: PLATFORM_URL,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(businessProfileId && { 'X-BU-PROFILE': businessProfileId })
    },
  });
};